export default {
  "content": "<path d=\"M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};